import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { useTranslation as e } from "../../hooks/useTranslation/index.js";
import { LoadingContainer as m, LoadingIcon as d, LoadingText as c } from "./style.js";
function f({
  background: n,
  className: i,
  hideLoadingText: r
}) {
  const { t } = e("common");
  return /* @__PURE__ */ a(m, { className: i, children: [
    /* @__PURE__ */ o(d, { background: n }),
    !r && /* @__PURE__ */ o(c, { children: t("loading-text") })
  ] });
}
export {
  f as Loading,
  d as LoadingIcon
};
